import http from 'api/http';
import { appointmentDomain } from 'models';
import {
  AppointmentResponse,
  CustomerAppointmentDetails,
  EnergyExpertsDetails,
  EVAppointmentDetails,
  EvIsolatorAppointmentDetails,
  MaintenanceDetails,
  SiteAbortDetails
} from 'models/Appointment';
import { createUrl, commonErrorHandling } from 'store/utils';

// This type guard has been added to make the logic in `fetchPreviousAborts` not have to cast complicated union types.
function isEnergyExpertsAppointment(
  appointmentDetails?:
    | (
        | MaintenanceDetails
        | CustomerAppointmentDetails
        | EVAppointmentDetails
        | EvIsolatorAppointmentDetails
      )
    | EnergyExpertsDetails
): appointmentDetails is EnergyExpertsDetails {
  return (
    (appointmentDetails as EnergyExpertsDetails)?.motivations !== undefined
  );
}

export async function fetchPreviousAborts(
  appointmentData: AppointmentResponse
): Promise<SiteAbortDetails | null> {
  const details = appointmentData.appointmentType?.details;

  if (isEnergyExpertsAppointment(details)) {
    return null;
  }

  const mpan = details?.mpan ?? null;
  const mprn = details && 'mprn' in details ? details.mprn : null;

  if ((mpan ?? mprn) === null) return null;

  try {
    const { data: previousAbortData } = await http.post<SiteAbortDetails[]>(
      `${createUrl(appointmentDomain)}/abort/search`,
      { sites: [{ mpan, mprn }] }
    );
    return previousAbortData ? previousAbortData[0] : null;
  } catch (error) {
    commonErrorHandling(error, appointmentDomain.type);
    return null;
  }
}
